// Approximate US state centroids used to auto-position a contact when the
// user adds them via the form (no map click) — matches backend/state_geo.py.

export const STATE_CENTROID = {
  AL: [32.806671, -86.79113], AK: [61.370716, -152.404419],
  AZ: [33.729759, -111.431221], AR: [34.969704, -92.373123],
  CA: [36.116203, -119.681564], CO: [39.059811, -105.311104],
  CT: [41.597782, -72.755371], DE: [39.318523, -75.507141],
  DC: [38.897438, -77.026817], FL: [27.766279, -81.686783],
  GA: [33.040619, -83.643074], HI: [21.094318, -157.498337],
  ID: [44.240459, -114.478828], IL: [40.349457, -88.986137],
  IN: [39.849426, -86.258278], IA: [42.011539, -93.210526],
  KS: [38.5266, -96.726486], KY: [37.66814, -84.670067],
  LA: [31.169546, -91.867805], ME: [44.693947, -69.381927],
  MD: [39.063946, -76.802101], MA: [42.230171, -71.530106],
  MI: [43.326618, -84.536095], MN: [45.694454, -93.900192],
  MS: [32.741646, -89.678696], MO: [38.456085, -92.288368],
  MT: [46.921925, -110.454353], NE: [41.12537, -98.268082],
  NV: [38.313515, -117.055374], NH: [43.452492, -71.563896],
  NJ: [40.298904, -74.521011], NM: [34.840515, -106.248482],
  NY: [42.165726, -74.948051], NC: [35.630066, -79.806419],
  ND: [47.528912, -99.784012], OH: [40.388783, -82.764915],
  OK: [35.565342, -96.928917], OR: [44.572021, -122.070938],
  PA: [40.590752, -77.209755], RI: [41.680893, -71.51178],
  SC: [33.856892, -80.945007], SD: [44.299782, -99.438828],
  TN: [35.747845, -86.692345], TX: [31.054487, -97.563461],
  UT: [40.150032, -111.862434], VT: [44.045876, -72.710686],
  VA: [37.769337, -78.169968], WA: [47.400902, -121.490494],
  WV: [38.491226, -80.954453], WI: [44.268543, -89.616508],
  WY: [42.755966, -107.30249],
};

/**
 * Return a random point inside ~1.1° radius from the state centroid.
 * Used when the user adds a contact by state, without pinning on the map.
 * Returns null if the state code is unknown.
 */
export function jitterInState(code) {
  const ctr = STATE_CENTROID[code];
  if (!ctr) return null;
  const r = Math.sqrt(Math.random()) * 1.1;
  const theta = Math.random() * 2 * Math.PI;
  const dlat = r * Math.cos(theta);
  const lat_rad = (ctr[0] * Math.PI) / 180;
  const dlng = (r * Math.sin(theta)) / Math.max(Math.cos(lat_rad), 0.4);
  return [
    Math.round((ctr[0] + dlat) * 1e5) / 1e5,
    Math.round((ctr[1] + dlng) * 1e5) / 1e5,
  ];
}
